module.exports = __webpack_public_path__ + "img/serverurl.480cc952.png";